import Moment from "react-moment";
import { useEffect, useState } from "react";
import { CgMenuGridR } from "react-icons/cg";
import WallBookingPanel from "./WallBookingPanel";

export default function WallBookingNew({ bookings, isLoading }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);

  const goToIndex = (index: any) => {
    setCurrentIndex(index);
  };

  const getData = () => {

    const groupedData = bookings?.reduce((acc: any, item: any) => {
      const timeId = item?.slottime?._id;
      if (!acc[timeId]) {
        acc[timeId] = [];
      }
      acc[timeId].push(item);
      return acc;
    }, {});

    const slots = Object.keys(groupedData).map((timeId) => ({
      timeId,
      start: groupedData[timeId][0]?.slottime?.starttime,
      end: groupedData[timeId][0]?.slottime?.endtime,
      data: groupedData[timeId].slice(0, 10),
    }));

    slots.sort((a: any, b: any) => {
      if (a.order < b.order) return -1;
      if (a.order > b.order) return 1;
      return 0;
    });

    return slots;
  };

  const data = getData();


  const [currentIndex, setCurrentIndex] = useState(0);

  const nextIndex = () => {
    const newIndex = (currentIndex + 1) % data?.length;
    setCurrentIndex(newIndex);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextIndex();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [currentIndex]);

  useEffect(() => {
    setVisible(true);
    const interval = setInterval(() => {
      setVisible(false);
    }, 4000);

    return () => {
      clearInterval(interval);
    };
  }, [currentIndex]);


  useEffect(() => {
    goToIndex(0)
  },[])

  if (isLoading) {
    return (
      <div className="flex justify-center bg-toyota">
      </div>
    );
  }
  return (
    <div className="flex justify-start items-start w-full">
      <div className="flex flex-col">
        {data?.map((slot: any, index: number) => {
          return (
            <button
              key={index}
              className={`flex items-center flex-1 w-full px-6 text-xl py-4 text-white ${
                index === currentIndex ? "bg-white text-toyota" : "text-white"
              }`}
              onClick={() => goToIndex(index)}
            >
              <div className="">
                <CgMenuGridR />
              </div>
              <div className="ml-1">
                <div>
                  <>
                    {slot?.start === null ? (
                      "-"
                    ) : (
                      <>
                        <Moment format="HH:mm A">{slot?.start}</Moment>
                        <span className="mx-1">-</span>
                        <Moment format="HH:mm A">{slot?.end}</Moment>
                      </>
                    )}
                  </>
                </div>
              </div>
            </button>
          );
        })}
      </div>
      <WallBookingPanel
        isVisible={isVisible}
        setVisible={setVisible}
        slot={data[currentIndex]}
      />
    </div>
  );
}
